export const getDossiersByAzienda = `
query getDossiers($tenantId:String!,$aziendaId:Int!,$userId:String!){
    getDossiers(tenantId:$tenantId,aziendaId:$aziendaId,userId:$userId){
        path
        pathId
        id
        cf
        pIva
        denominazione
        ppe
        rischioAreaGeo
        fascicoloId
        fascicolo
        data
        aziendaId
        isPg
        isCfWrong
        isPivaWrong
        tipoAnagrafica
    }
}`;